/*----- Core -----*/
import { takeLatest, put, call } from 'redux-saga/effects'

/*----- Components -----*/
import Notification from "../../components/commons/Notification"

/*----- Constants -----*/
import {
 	GET_PRODUCER,
  GET_PRODUCER_SUCCESS,
	GET_PRODUCER_FAIL
} from './Constants'

import { PRODUCERS } from '../app/Constants'

/*----- Firestore -----*/
import { db } from '../../Firebase'

function* shootGetProducer(action) {

	let type
	let data = {}

	function* getProducer () {
		
		const { producerId }	= action.payload
		const producertRef    = db.collection( PRODUCERS ).doc(producerId)

		yield producertRef.get()
			.then(doc => {
				return data = doc.data()
			})
			
	}

	try {
		yield call(getProducer)
		yield type = GET_PRODUCER_SUCCESS
	} catch (error) {
		type = GET_PRODUCER_FAIL
		data = error.message
		Notification(error.message, 'error')
	}
	
	yield put({type: type, payload: data})

}
export default function* getProducertWatcher() {
  yield takeLatest(GET_PRODUCER, shootGetProducer)
}